import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { showToast } from '../../components/Toast/showToast';
import * as calls from './credits.calls';
import * as actions from './credits.action';
import {
  ApplyCouponRequestAction,
  CouponsSuccessAnswer,
  ApplyRetentionCouponRequestAction
} from './credits.types';
import { extractErrorAndShowToast } from '../../utils/helpers/extractErrorAndShowToast';
import i18n from '../../locale/i18n';

function* getCoupons() {
  try {
    const {
      data: { coupons, couponsBalance, couponsTotal, couponsUsedAmount }
    }: AxiosResponse<CouponsSuccessAnswer> = yield call(calls.getCoupons);

    yield put(
      actions.getCouponsSuccess({ coupons, couponsBalance, couponsTotal, couponsUsedAmount })
    );
  } catch (e) {
    if (e.response) {
      const { data } = e.response;

      yield put(actions.getCouponsFailure(data));
      extractErrorAndShowToast(e);
    }
  }
}

function* applyCoupon(action: ApplyCouponRequestAction) {
  try {
    yield call(calls.applyCoupon, action.payload);
    yield getCoupons();
    showToast(i18n.t('billingAndPayments.tabs.credits.success'), 'success');
  } catch (e) {
    if (e.response) {
      const { data } = e.response;
      showToast(i18n.t(`billingAndPayments.tabs.credits.errors.${data.errors.code}`));
    }
  }
}

function* applyRetentionCoupon(action: ApplyRetentionCouponRequestAction) {
  try {
    const result = yield call(calls.applyCoupon, action.payload);
    const {
      data: {
        accountCoupon: { amount }
      }
    } = result;
    showToast(i18n.t('retention.couponToastSuccess', { amount }), 'success');
  } catch (e) {
    if (e.response) {
      const { data } = e.response;
      showToast(i18n.t(`billingAndPayments.tabs.credits.errors.${data.errors.code}`));
    }
  }
}

function* creditsSaga() {
  yield takeLatest('GET_COUPONS_REQUEST', getCoupons);
  yield takeLatest('APPLY_COUPON_REQUEST', applyCoupon);
  yield takeLatest('APPLY_RETENTION_COUPON_REQUEST', applyRetentionCoupon);
}

export default creditsSaga;
